<template>
  <div class="wrapper">
    <BPMNNodeBase :item="item" @updateName="updateName"/>
    <div class="container-fluid">
      <div class="form-group mt-2">
        <label>Script Modul:</label>
        <select v-if="taskName" @change="updateScript" v-model="script" class="form-control">
          <option value="">-</option>
          <option v-for="s in scriptlist" :key="s.id" :value="s.id">{{ s.id }}</option>
        </select>
      </div>
      <!-- TODO Params injection from script input params -->
      <div class="form-group mt-2">
        <label>Ergebnis Variable</label>
        <input v-if="targetVar" v-model="outVar" @change="updateVar" type="text" class="form-control" placeholder="Prozessvariable für das Ergebniss des Scripts"/>
      </div>

      <div v-if="scriptEntry" class="wrapper">
        <div v-for="(p,key) in scriptEntry.input" :key="key" class="form-group">
          <label>{{ p.name }}</label>
          <div class="input-group">
            <input v-model="jparams[p.name]" :placeholder="p.hint" type="text" class="form-control" @change="updateParams"/>
            <div class="input-group-append">
              <button @click="selectVariable(key)" class="btn btn-primary">...</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import BPMNNodeBase from './BPMNNodeBase.vue'
import scripttasks from '@/modules/scripttasks.js'

export default {
  name: 'BPMNScriptTask',
  props: ['item'],
  data() {
    return {
      taskName: false,
      targetVar: false,
      params: false,
      jparams: {},
      script: '',
      outVar: '',
      scriptlist: [],
      scriptEntry: false,
      extensions: false,
    }
  },
  components: {
    BPMNNodeBase
  },
  watch: {
    item: function() {
      console.log('item updated');
      // reset view states
      this.extensions = false;
      this.scriptEntry = false,
      this.taskName = false;
      this.targetVar = false;
      this.params = false;
      this.jparams = {};
      this.script = '';
      this.outVar = '';
      this.parseItem();
      this.selectScript();
    }
  },
  created: function() {
    this.parseItem();
    this.fetchData();
  },
  mounted() {

  },
  methods: {
    selectVariable() {
      console.log('open select variable');
    },
    updateName(n) {
      this.$emit('updateName',n);
    },
    selectScript() {
      console.log('script select ',this.script);
      var key = this.script;
      this.scriptEntry = false;
      for (var i in this.scriptlist) {
        console.log('search candidate: ',this.scriptlist[i].id);
        if (this.scriptlist[i].id == key) {
          this.scriptEntry = this.scriptlist[i];
          console.log('script found: ',this.scriptEntry);
          break;
        }
      }
    },
    updateScript() {
      console.log(this.script);
      this.taskName.children[0].children[0].content = this.script;
      this.selectScript();
    },
    updateVar() {
      console.log(this.outVar);
      this.targetVar.children[0].children[0].content = this.outVar;
    },
    updateParams() {
      this.params.children[0].children[0].content = JSON.stringify(this.jparams);
    },
    fetchData() {
      var self = this;
      scripttasks.list(this,-2,function(data) {
        self.scriptlist = data;
        self.selectScript();
      })
    },
    parseItem() {
      // parse given extension parameter
      for (var i in this.item.children) {
        var child = this.item.children[i];
        console.log(child.localName);
        if (child.localName == 'extensionElements') {
          this.extensions = child;
          if (child.children) {
            for (var si in child.children) {
              var sub = child.children[si];
              if (sub.attributes["name"]) {
                if (sub.attributes["name"].value == 'taskName') {
                  this.taskName = sub;
                } else if (sub.attributes["name"].value == 'targetVar') {
                  this.targetVar = sub;
                } else if (sub.attributes["name"].value == 'param') {
                  this.params = sub;
                }
              } // if has name
            } // check child extensions
          } // echeck extensions children

          break;

        }  // check extensionsElement
      } // check for extension element

      if (!this.extensions.children) {
        this.extensions.children = [];
      }


      if (!this.taskName) {
        var defTaskName = {
          "localName":"field",
          "nodeName":"activiti:field",
          "ns":"http://activiti.org/bpmn",
          "type":1,
          "attributes": {
            "name": { "localName":"name", "nodeName":"name", "value":"taskName"}
          },
          "children": [
            {
              "localName":"string",
              "nodeName":"activiti:string",
              "ns":"http://activiti.org/bpmn",
              "type":1,
              "children": [
                { "type": 4, "content":"" }
              ]
            }
          ],
        };
        this.extensions.children.push(defTaskName);
        this.taskName = defTaskName;
      } else {
        this.script = this.taskName.children[0].children[0].content;
      }

      if (!this.targetVar) {
        var defTargetVar = {
          "localName":"field",
          "nodeName":"activiti:field",
          "ns":"http://activiti.org/bpmn",
          "type":1,
          "attributes": {
            "name": {
              "localName":"name",
              "nodeName":"name",
              "value":"targetVar"
            }
          },
          "children": [
            {
              "localName":"string",
              "nodeName":"activiti:string",
              "ns":"http://activiti.org/bpmn",
              "type":1,
              "children": [
                { "type": 4, "content":"" }
              ]
            }
          ],
        };
        this.extensions.children.push(defTargetVar);
        this.targetVar = defTargetVar;
      } else {
        this.outVar = this.targetVar.children[0].children[0].content;
      }

      if (!this.params) {
        var defParams = {
          "localName":"field",
          "nodeName":"activiti:field",
          "ns":"http://activiti.org/bpmn",
          "type":1,
          "attributes": {
            "name": {
              "localName":"name",
              "nodeName":"name",
              "value":"param"
            }
          },
          "children": [
            {
              "localName":"expression",
              "nodeName":"activiti:expression",
              "ns":"http://activiti.org/bpmn",
              "type":1,
              "children": [
                { "type": 4, "content":"{}" }
              ]
            }
          ],
        };
        this.extensions.children.push(defParams);
        this.params = defParams;
        this.jparams = {};
      } else {
        this.jparams = JSON.parse(this.params.children[0].children[0].content);
      }

      console.log('got params:',this.jparams);
    }
  }
}
</script>
